<template>
    <div>
      <v-dialog name="dialog" />
      <div class="admin_title">培训计划管理</div>
      <div class="gj_top_class">
        <input type="button" class="btn_s_gj" v-debounce-click @click="search(filters)"/>
        <input type="text" class="put_gj" v-model="filters.title" @keyup.13="search(filters)" />
        <select v-model="filters.isPublished" @change="search(filters)">
          <option value="">状态</option>
          <option value="1">已发布</option>
          <option value="0">未发布</option>
        </select>
        <a @click="to('plan', 'void')">新增培训计划</a>
      </div>
      <div class="training_list" style="min-height: 480px;">
        <!--暂无计划提示-->
        <h5 class="none_ts" v-if="lists.length == '0'">
          <img src="@/assets/images/none_data.jpg" alt="">
        </h5>
        <!--暂无计划提示-->
        <!--计划列表-->
        <dl v-for="item in lists" :key="item.id">
          <dt style="position: relative;">
            <div style="position: absolute; top: 0; z-index: 3;">
              <img v-if="!item.coverUrl || item.coverUrl == ''" src="@/assets/images/zy_default.png" width="220" height="94">
              <img v-if="item.coverUrl && item.coverUrl!==''" :src="item.coverUrl" width="220" height="94" />
            </div>
            <div style="position: absolute; top: 0; width: 100%; height: 100%; background: rgba(0, 0, 0, 0.4); z-index: 4;"></div>
            <h3 style="position: relative; z-index: 6;">{{item.title}}</h3>
            <!--ul class="col_2_1">应培训 <span>0/12</span> 人</ul-->
            <ul class="col_2_2 total-scope-train" style="z-index: 9;">
              <p>操作</p>
              <li class="total-scope-tan" style="display: none;">
                <a v-debounce-click @click="to('plan', item.id)">编辑</a>
                <a v-if="item.isPublished == '0'" v-debounce-click @click="pub(item.id)">发布</a>
                <a v-if="item.isPublished == '1'" v-debounce-click @click="unpub(item.id)">取消发布</a>
                <a v-debounce-click @click="copy(item.id)">复制</a>
                <a v-debounce-click @click="del(item.id)">删除</a>
              </li>
            </ul>
          </dt>
          <dd>
            <span class="col_2_1">
              <b class="red_font" v-if="item.price > 0">￥{{item.price}}</b>
              <b class="red_font" v-if="item.price == 0">免费</b>
            </span>
            <span class="red_font col_2_2">{{item.isPublished == '0' ? '未发布' : '已发布'}}</span>
          </dd>
        </dl>
        <!--/计划列表-->
      </div>
      <div class="zy_list_bottom mtf30">
        <dl>
          <dt v-if="cnt && cnt > 0"><!--<input id="sel_1" onchange="selectAll()" type="checkbox" value="1" style="opacity: 1;"/> 全选 <input name="" type="button" value="批量上架" class="btn_zy_bottom" /> <input name="" type="button" value="批量下架"  class="btn_zy_bottom"/> <input name="" type="button" value="删除所选"  class="btn_zy_bottom" />-->共{{cnt}}个计划</dt>
          <dd v-if="cnt>0">
            <paginate :click-handler="clickCallback" :page-count=pages
                      :container-class=$global.paginationOptions.container_class :page-class=$global.paginationOptions.page_class :page-link-class=$global.paginationOptions.page_link_class
                      :prev-class=$global.paginationOptions.prev_class :prev-link-class=$global.paginationOptions.prev_link_class
                      :next-class=$global.paginationOptions.next_class :next-link-class=$global.paginationOptions.next_link_class
                      :first-last-button=$global.paginationOptions.first_last_button
                      :active-class=$global.paginationOptions.active_class
                      :disabled-class=$global.paginationOptions.disabled_class
                      :first-button-text=$global.paginationOptions.first_button_text
                      :last-button-text=$global.paginationOptions.last_button_text
                      :prev-text=$global.paginationOptions.prev_text
                      :next-text=$global.paginationOptions.next_text>
            </paginate>
          </dd>
        </dl>
      </div>
      <div class="clear"></div>
    </div>
</template>

<script>
  import {init} from '@/assets/js/public'
  import Paginate from 'vuejs-paginate'
  import utils from '@/utils'
  import config from '@/config'
  import api from '@/api'
  export default {
    components: { Paginate },
    data () {
      return {
        lists: [],
        filters: {
          pageNo: 1,
          pageSize: 12,
          title: '',
          delFlag: '0',
          isPublished: ''
        },
        pages: 0,
        cnt: 0
      }
    },
    created () {
      this.search(this.filters)
    },
    mounted () {
      this.$on('data-prepared', function () {
        this.$nextTick(() => {
          init()
        })
      })
    },
    methods: {
      clickCallback (pageNum) {
        this.filters.pageNo = pageNum
        this.search(this.filters)
      },
      confirmBox (o) {
        this.$modal.show('dialog', {
          title: o.title,
          text: o.text,
          buttons: [
            {
              title: '确认',
              default: true,
              handler: utils.debounce(() => {
                if (o.yes && o.yes instanceof Function) {
                  o.yes()
                }
              }, 1000)
            },
            {
              title: '取消'
            }
          ]
        })
      },
      to (path, id) {
        this.$router.push({
          path: path + '/' + id
        })
      },
      copy (id) {
        if (id) {
          var that = this
          this.confirmBox({
            title: '复制',
            text: '确认复制吗?',
            yes: function () {
              api.post(config.planApiPath, '/trainingplans/copy/' + id, null, r => {
                that.$toasted.show('复制成功')
                that.search(that.filters)
                that.$modal.hide('dialog')
              })
            }
          })
        }
      },
      pub (id) {
        if (id) {
          var that = this
          this.confirmBox({
            title: '发布',
            text: '确认发布吗?',
            yes: function () {
              api.post(config.planApiPath, '/trainingplans/enable/' + id, null, r => {
                that.$toasted.show('发布成功')
                that.search(that.filters)
                that.$modal.hide('dialog')
              })
            }
          })
        }
      },
      unpub (id) {
        if (id) {
          var that = this
          this.confirmBox({
            title: '取消发布',
            text: '取消发布吗?',
            yes: function () {
              api.post(config.planApiPath, '/trainingplans/disable/' + id, null, r => {
                that.$toasted.show('取消发布成功')
                that.search(that.filters)
                that.$modal.hide('dialog')
              })
            }
          })
        }
      },
      del (id) {
        if (id) {
          var that = this
          this.confirmBox({
            title: '删除',
            text: '确认删除吗?',
            yes: function () {
              api.post(config.planApiPath, '/trainingplans/delete/' + id, null, r => {
                that.$toasted.show('删除成功')
                that.search(that.filters)
                that.$modal.hide('dialog')
              })
            }
          })
        }
      },
      search (filters) {
        var that = this
        if (!filters.title) { delete filters.title }
        api.post(config.planApiPath, '/trainingplans/search', filters, function (r) {
          that.lists = r.data
          that.cnt = r.cntData
          that.pages = r.cntPage
          that.$emit('data-prepared')
        })
      }
    }
  }
</script>

<style scoped>
  .training_list dl dt ul li {height: 130px !important; }
</style>



// WEBPACK FOOTER //
// src/page/byl/org/plan/list.vue